import { cn } from '@/shared/lib'

import { Icon } from '../icon'
import { buttonVariants, type ButtonVariantsProps } from './variants'

type Props = ButtonVariantsProps & {
  onClick: () => void
  disabled?: boolean
}

export const GoToFirstPageButton = ({
  mode,
  disabled = false,
  onClick,
}: Props) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        buttonVariants({
          mode,
          selected: false,
          disabled,
        }),
        'text-black disabled:text-gray-400',
      )}
    >
      <Icon name="arrow-first" size={18} />
    </button>
  )
}

export const GoToPreviousPageButton = ({
  mode,
  disabled = false,
  onClick,
}: Props) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        buttonVariants({
          mode,
          selected: false,
          disabled,
        }),
        'text-black disabled:text-gray-400',
      )}
    >
      <Icon name="arrow-left" size={18} />
    </button>
  )
}

export const GoToNextPageButton = ({
  mode,
  disabled = false,
  onClick,
}: Props) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        buttonVariants({
          mode,
          selected: false,
          disabled,
        }),
        'text-black disabled:text-gray-400',
      )}
    >
      <Icon name="arrow-right" size={18} />
    </button>
  )
}

export const GoToLastPageButton = ({
  mode,
  disabled = false,
  onClick,
}: Props) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        buttonVariants({
          mode,
          selected: false,
          disabled,
        }),
        'text-black disabled:text-gray-400',
      )}
    >
      <Icon name="arrow-last" size={18} />
    </button>
  )
}
